import cx from 'classnames'

type Props = {
  src?: string | null
  title?: string | null
  className?: string
}

export const Image = ({src, title, className}: Props) => {
  if (src) {
    return (
      <img src={src} className={cx('w-[72px] min-w-[72px] h-[72px] rounded-lg', className)} alt={title || 'Tour'} />
    )
  }

  return <div className={cx('bg-gray-300 w-[72px] min-w-[72px] h-[72px] rounded-lg', className)} />
}
